export default __webpack_public_path__ + "static/media/product-14.ae77f2df.webp";